import React, {useEffect} from "react";
import css from './floatmenu.module.scss'
import {observer} from "mobx-react";
import {makeAutoObservable} from "mobx";
import classNames from "classnames";
import MyRouter from "router/router";
import {useHistory} from "react-router-dom";
import useMyStores from "@/hooks/useMyStores";
import useUserState from "hooks/useUserState.ts";

class FloatMenuStore {

    visible = false;
    currentFloorId = 0;
    currentNavIndex = -1;

    setVisible(value) {
        this.visible = value
    }

    get isHide() {
        return !this.visible
    }

    constructor() {
        makeAutoObservable(this)
    }
}

const floatMenuStore = new FloatMenuStore();

class Nav {
    isLogin = false;
    // 显示登录表单
    showLogin = () => {
    }
    // 显示客服
    showService = () => {
    }
    history = undefined;


    constructor({isLogin, showLogin, showService, history}) {
        this.isLogin = isLogin;
        this.showLogin = showLogin;
        this.showService = showService;
        this.history = history;
    }

    list = [
        // 收藏
        {
            icon: require('./img/悬浮收藏.png'),
            onClick: () => {
                if (!this.isLogin) {
                    this.showLogin()
                } else {
                    window.open(MyRouter.basename + MyRouter.User.path + "?currentIndex=2");
                }
            },
            style: {
                width: 34,
                height: 32,
                top: 16,
                left: 14
            }
        },
        // 购物车
        {
            icon: require('./img/悬浮购物车.png'),
            onClick: () => {
                if (!this.isLogin) {
                    this.showLogin()
                } else {
                    this.history.push({
                        pathname: `${MyRouter.Cart.path}`
                    });
                }
            },
            style: {
                width: 34,
                height: 32,
                top: 15,
                left: 13
            }
        },
        // 客服
        {
            icon: require('./img/悬浮客服.png'),
            onClick: () => {
                if (!this.isLogin) {
                    this.showLogin()
                } else {
                    this.showService()
                }
            },
            style: {
                width: 36,
                height: 36,
                top: 14,
                left: 13
            }
        },
        // 个人中心
        {
            icon: require('./img/悬浮我的.png'),
            onClick: () => {
                if (!this.isLogin) {
                    this.showLogin()
                } else {
                    // this.props.history.push({
                    //   pathname: `${Router.User.path}`
                    // });
                    window.open(MyRouter.basename + MyRouter.User.path);
                }
            },
            style: {
                width: 31,
                height: 30,
                top: 15,
                left: 15
            }
        }
    ];
}

const Index = (
    {
        homeScroll = {},
        homeScrollToTop = () => {
        },
        homeSize = {},
        floorIds = []
    }
) => {

    const {login: loginStore, service: serviceStore} = useMyStores()

    const userState = useUserState()

    const history = useHistory()
    const nav = new Nav({
        isLogin: userState.isLogin,
        showLogin: () => loginStore.show = true,
        showService: () => serviceStore.show = true,
        history
    })

    // const toTop = ()=>{
    //     document.documentElement.scrollTo(0, 0);
    // }

    const refreshShow = ({floorIds, homeScrollTop, homeHeight}) => {
        if (!floorIds.length || !homeScroll.top || !homeSize.height) {
            return;
        }

        const firstFloorId = floorIds?.[0]

        if (!firstFloorId) {
            return;
        }

        let startDom = document.querySelector(`#floor-${firstFloorId}`);
        let endDom = document.querySelector("#center");

        if (!startDom || !endDom) {
            return;
        }

        // const scrollTop = homeScroll.top || 0;
        // const clientHeight = homeSize.height || 0;

        if (homeScrollTop + homeHeight / 2 >= startDom.offsetTop) {
            floatMenuStore.setVisible(true)
        } else {
            floatMenuStore.setVisible(false)
        }

        // if (scrollTop + clientHeight >= endDom.offsetTop) {
        //   this.setState({
        //     show: false
        //   });
        // }
    };

    useEffect(() => {

        refreshShow({
            floorIds,
            homeScrollTop: homeScroll.top,
            homeHeight: homeSize.height,
        })

        // const scroll = () => {
        //     refreshShow({floorIds,homeScrollTop,homeHeight})
        // }
        // // refreshShow();
        // window.addEventListener("scroll", scroll);
        //
        // return () => {
        //     window.removeEventListener("scroll", scroll);
        // }
    }, [floorIds.length, homeScroll.top, homeSize.height]);

    return (
        <div className={css.root}>
            <div className={classNames(css.container, {
                [css.hide]: floatMenuStore.isHide
            })}>
                <div className={css.card}>
                    {
                        nav.list.map((item, i) => {
                            const {icon, style, onClick} = item
                            return (
                                <div key={i} className={css.item} onClick={onClick}>
                                    <img src={icon} alt="" className={css.icon} style={style}/>
                                </div>
                            )
                        })
                    }
                </div>

                <div className={css.toTopWrapper} onClick={homeScrollToTop}>
                    <div className={css.iconWrapper}>
                        <img src={require("./img/悬浮top.png")} alt=""/>
                    </div>
                    <div className={css.textWrapper}>
                        <div className={css.text}>
                            top
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(Index)